import { Loader } from "@itandi/itandi-bb-ui";
import type { FC } from "react";
import { VendorSettingLayout } from "~/components/common/layouts/settings/VendorSettingLayout";
import { VendorLayoutV2 } from "~/components/common/layouts/VendorLayoutV2";
import { AccountSetting } from "~/components/specifics/vendors/settings/accounts/AccountSetting";
import { ProfileSetting } from "~/components/specifics/vendors/settings/profiles/ProfileSetting";
import { useSessions } from "~/hooks/vendors/useSessions";

export const Page: FC = () => {
	const { data: session } = useSessions().index();

	if (session === null) {
		return <Loader />;
	}

	return (
		<VendorLayoutV2>
			<VendorSettingLayout spMenu>
				{session.admin ? (
					<AccountSetting session={session} />
				) : (
					<ProfileSetting />
				)}
			</VendorSettingLayout>
		</VendorLayoutV2>
	);
};
